import React, {FC} from 'react';
import cnBind from 'classnames/bind';
import dayjs from 'dayjs';
import {useStoreon} from 'storeon/react';
import {GxIcon} from '@garpix/garpix-web-components-react';
import { api } from '@/api';
import { Events, State } from '@/interfaces';
import {MinusIcon, PlusIcon} from '../../../../assets';
import styles from '../TableItem/styles/index.module.scss';
import {TypeRange, TypeTable} from '../../interfaces';
import UserCard from '../UserCard';
import {ORDERS} from '../../../../const';
import {findTariff} from '../../helpers';
import { IDataWeek } from '../ModalUser/types';

const { v4: uuidv4 } = require('uuid');

interface ITbodyWeekContent {
	dataWeek?: IDataWeek[];
	rangeType: TypeRange;
	typeTable: TypeTable;
	time?: string;
	handleClickModal: ( date: string | null, info: Record<string, any> | null ) => void;
	openModalOrder: ( data: Record<string, any>) => void;
}

const TbodyWeekContent: FC<ITbodyWeekContent> = ( {
  dataWeek,
  rangeType,
  typeTable,
  handleClickModal,
  openModalOrder,
  }): JSX.Element => {

	const {
		dispatch,
		applicationInfo,
		statusCreateMultiOrders,
		arrayDateTimeOrders,
		typeOrder,
		ordersInfo
	} = useStoreon<State, Events>(
		'ordersInfo',
		'applicationInfo',
		'statusCreateMultiOrders',
		'arrayDateTimeOrders',
		'typeOrder',
		'ordersInfo'
	);

	const cn = cnBind.bind(styles);
	let tableRow: React.ReactElement[] = [];
	const addItemInMultiOrder = async ( time: string, date: string ) => {
		try {
			const actual_tariffs = await api.tariff.getActualTariff({
				time,
				date: dayjs(date).format('YYYY.MM.DD'),
				side: typeOrder
			});
			if (statusCreateMultiOrders) {
				let info = findTariff(
					actual_tariffs,
					typeOrder,
					applicationInfo?.customer,
					applicationInfo?.tariff_rate_multi.value,
					{
						time,
						date: ordersInfo.date
					},
					applicationInfo?.is_children
				);
				if (info.tariff && info.rate) {
					dispatch('arrayDateTimeOrders/add', {
						time,
						date: dayjs(date).format('YYYY.MM.DD'),
						data: info
					});
				}
			} else {
				handleClickModal(`${dayjs(date).format('YYYY.MM.DD')} ${time}`, null);
			}

		} catch (e) {
			console.log(e);
		}
	};

	if (dataWeek && dataWeek.length !== 0 ) {
		let item = Object.entries(dataWeek && dataWeek[ 0 ].orders);
		tableRow = item.map(( [time] ) => (
				<tr className={styles[ 'body_row__week' ]} key={uuidv4()}>
					<td style={{ padding: '0 5px' }}>
						{time}
					</td>
					{dataWeek.map(( item, indexItem: number ) => (
						<td key={item.date} className={styles[ 'body_row__item' ]}>
							<div className={
								cn({
									'card__minutes': true,
									'card__minutes_compact': typeTable === 'compact',
									'card__minutes_week': rangeType === 'week',
									'card__minutes__half_hour': typeOrder === ORDERS.PIPE ? item.orders[ time ].have_free_session === 30 : item.orders[ time ].have_free_session === 15,
									'card__checked': arrayDateTimeOrders.some(( el ) => el.time === time && el.date === dayjs(item.date).format('YYYY.MM.DD')),
									'card__minutes__disabled_week': !item.orders[ time ].is_allowed,
									'card__minutes__restriction': item.orders[ time].is_has_session_restriction || item.orders[ time ].have_free_session < 0
								})}
							>
							<span
								className={styles[ 'card__minutes__count' ]}
							>
								{
									`${item.orders[ time ].have_free_session} ${typeOrder === ORDERS.PIPE ? 'мин.' : 'чел.'}`
								}
							</span>
								<div className={styles[ 'card__minutes__btn' ]}>
									{arrayDateTimeOrders.some(( el ) => el.time === time && el.date === dayjs(item.date).format('YYYY.MM.DD')) ?
										<GxIcon
											className={cn({
												'card__minutes__btn__icon': true,
												'card__minutes__btn__icon_red': !item.orders[ time ].is_allowed
											})} src={MinusIcon}
											onClick={() => dispatch('arrayDateTimeOrders/delete', {
												time,
												date: dayjs(item.date).format('YYYY.MM.DD')
											})}
										/>
										:
										<GxIcon
											className={cn({
												'card__minutes__btn__icon': true,
												'card__minutes__btn__icon_red': !item.orders[ time ].is_allowed
											})} src={PlusIcon}
											onClick={() => addItemInMultiOrder(time, item.date)}
										/>
									}
								</div>
							</div>

							{typeTable === 'default' &&
                <>
									{item.orders[ time ].orders.map(( order: Record<string, any>) => 
												<UserCard openModalOrder={openModalOrder} key={order.id} data={order} index={indexItem}/>
									)}
                </>
							}
						</td>
					))}
				</tr>
			)
		);
	}
  return <>{tableRow}</>
};
export default TbodyWeekContent;